// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__L4rOf","defaultTriggerClassName":"styles_defaultTriggerClassName__HOmg5"};